import React from 'react';
export function PainSection() {
  return <section className="w-full bg-white py-10 md:py-16 px-6" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-[#1a1a2e]" data-id="element-111">
          <p data-id="element-112">It starts with a simple request: "Five more minutes, okay?"</p>

          <p data-id="element-113">
            But five minutes becomes twenty. And when you finally reach out to
            take the device, something terrifying happens.
          </p>

          <p data-id="element-114">
            The "Zombie Look" vanishes, replaced by pure, raw aggression. The
            screaming. The door slamming. The look of genuine hatred in your
            child's eyes just because you interrupted their scroll.
          </p>

          <p className="font-bold text-xl md:text-2xl pt-4" data-id="element-115">
            This isn't just "kids being kids."
          </p>

          <p data-id="element-116">
            Every minute they spend glued to that screen, their brain is being
            rewired. They aren't playing; they are being harvested for dopamine.
          </p>

          <p className="font-semibold text-xl md:text-2xl pt-6" data-id="element-117">
            If you don't intervene now, you aren't just losing the afternoon—you
            are losing your child's future.
          </p>

          <p className="pt-4" data-id="element-118">
            Studies show that unregulated screen addiction at this age leads to:
          </p>

          <div className="space-y-6 pt-6 pl-4 border-l-4 border-[#1a56db]" data-id="element-119">
            <div data-id="element-120">
              <p className="font-bold text-xl mb-2" data-id="element-121">
                Permanent Attention Deficit:
              </p>
              <p data-id="element-122">
                They lose the ability to focus on anything that doesn't
                "sparkle" or "vibrate."
              </p>
            </div>

            <div data-id="element-123">
              <p className="font-bold text-xl mb-2" data-id="element-124">Emotional Stuntedness:</p>
              <p data-id="element-125">
                They forget how to read human faces, preferring emojis to eye
                contact.
              </p>
            </div>

            <div data-id="element-126">
              <p className="font-bold text-xl mb-2" data-id="element-127">
                The "Shadow" Relationship:
              </p>
              <p data-id="element-128">
                Every time you yell to get them off the Xbox, a brick is added
                to the wall between you. One day, that wall will be too high to
                climb over.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}